import { useEffect } from 'react'
import { useLocation } from 'react-router'

export default function ScrollToTop() {
  const { pathname } = useLocation()

  // run the effect on pathname or search change
  // biome-ignore lint/correctness/useExhaustiveDependencies(pathname): suppress dependency pathname
  useEffect(() => {
    requestAnimationFrame(() => {
      document.documentElement.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant',
      })
    })
  }, [pathname])

  return null
}
